<template>
  <v-badge
    v-if="isAnalysesAvailable"
    color="error"
    offset-x="20"
    offset-y="20"
    :content="analysesCountInCartContent"
    :value="analysesCountInCartContent"
  >
    <v-btn
      icon
      data-qa="cart-icon-header"
      :href="analysesPath"
      :small="isMobile"
    >
      <v-icon>
        ui-icon-cart
      </v-icon>
    </v-btn>
  </v-badge>
</template>

<script setup lang="ts">
import { computed, Ref } from 'vue'
import type { ContextStore } from 'src/layouts/core-layout/types'
import { useURLStore, useContextStore, useAnalysesStore } from 'src/store'

const { context }: ContextStore = useContextStore()
const { reverseFull } = useURLStore()
const { isAnalysesAvailable, analysesCountInCartContent } = useAnalysesStore()
const isMobile = context.flavour === 'mobile'

const analysesPath: Ref<string> = computed(() => {
  const { lpu_id: lpuId } = context.request.GET
  const url = new URL(reverseFull({ name: 'analyses_cart_content', args: [context.town.translit] }))

  if (lpuId && context.request.path.includes('/analyses/')) {
    url.searchParams.set('lpu_id', lpuId)
  }

  return url.href
})
</script>
